/*
 * GENERATED — DO NOT EDIT.
 * Web (wasmJs + js) actual for WorkerKmpAuto.install() — no-arg, parameterless factory.
 */
package cmp.shared.generated

public actual object WorkerKmpAuto {
    public actual fun install() {
        installWorkerKmpWeb()
    }
}
